module.exports = __webpack_public_path__ + "img/leftBox2.f1110c97.png";